import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import {
  getVariantData,
  updatingSelectedData,
  setVariantData,
} from '../../Actions/FindMyPart.action';

const ProductOptions = () => {
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  const [localVariantData, setLocalVariantData] = useState({});
  const [userText, setUserText] = useState('');
  const variantData = useSelector((state) => state.findMyPart.variantData);
  const buyButtonStatusClass = useSelector(
    (state) => state.findMyPart.buyButtonStatusClass
  );
  const returnMessage = useSelector((state) => state.findMyPart.returnMessage);
  const configMessage = useSelector((state) => state.findMyPart.configMessage);

  useEffect(() => {
    async function setup() {
      //dispatch(getVariantData(baseProductSystemId));
    }
    setup();
  }, []);

  useEffect(() => {
    if (variantData?.items?.length > 0) {
      setLocalVariantData(variantData);
      setMounted(true);
    }
  }, [variantData]);

  useEffect(() => {
    if (localVariantData?.items?.length > 0) {
      dispatch(updatingSelectedData(localVariantData));
    }
  }, [localVariantData]);

  const sendData = () => {
    dispatch(setVariantData(localVariantData, userText));
  };

  const setValue = (index1, index2) => {
    const tempVariantData = { ...localVariantData };
    tempVariantData.items[index1].variantData.map((item, i) => {
      if (i === index2) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
    setLocalVariantData(tempVariantData);
  };

  if (!mounted || !localVariantData) {
    return null;
  }
  return (
    <div className="row small-up-1 product-configurator">
      {localVariantData?.items?.length > 0 && (
        <Fragment>
          {localVariantData.items.map((item, index) => (
            <div
              key={`items_${index}`}
              className="columns product-configurator__items"
            >
              <h2 className="product-detail__selector-item-title">
                {item.title}
              </h2>
              {item.variantData?.length > 0 && (
                <ul className="product-detail__selector-item-list">
                  {item.variantData.map((variantData, index2) => (
                    <li
                      key={`item_${index2}`}
                      className="product-detail__selector-item"
                    >
                      <div
                        onClick={() => setValue(index, index2)}
                        className={`product-detail__selector-link ${
                          variantData.selected
                            ? 'product-detail__selector-link--active'
                            : ''
                        }`}
                      >
                        {variantData.value}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </Fragment>
      )}
      <Fragment>
        <div className="product-detail__item-title">
          {translate('product.configurator.message')}
        </div>
        <textarea
          name="postContent"
          onChange={(e) => setUserText(e.target.value)}
        />
      </Fragment>
      {returnMessage && returnMessage.length > 0 && (
        <div
          className="product-configurator__return-message"
          dangerouslySetInnerHTML={{ __html: returnMessage }}
        />
      )}
      {configMessage && configMessage.length > 0 && (
        <div
          className="product-configurator__config-message"
          dangerouslySetInnerHTML={{ __html: configMessage }}
        />
      )}
      <span className={`buy-button${buyButtonStatusClass}`}>
        <button
          className={`button buy-button product-detail__buy-button`}
          onClick={sendData}
        >
          {translate('product.buy')}
        </button>
      </span>
    </div>
  );
};

export default ProductOptions;
